<script>
export default {
    name: "SupplierForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {
       // "initiate-payment-form": () => import('./tabs/Initiate.vue'),
       "initiate-payment-form": () => import('./tabs/payment-list.vue'),
        "supplier-statement-tab": () => import('./tabs/Statement.vue')
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <ul class="print:hidden w-full flex border-b-2 border-gray-500 mt-1">
            <li class="-mb-px mr-1">
                <a @click.prevent="active=0" href="javascript:void(0)" 
                  class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                  :class="active===0 ? activeClass : inActiveClass">Initiate Payment</a>
            </li>
            <li class="-mb-px mr-1">
                <a @click.prevent="active=1" href="javascript:void(0)" 
                  class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                  :class="active===1 ? activeClass : inActiveClass">Statement</a>
            </li>
        </ul>
        <initiate-payment-form v-if="active===0" />
        <supplier-statement-tab v-if="active===1" />
    </div>
</template>
